import type { ISeverity } from '@/types/severity'
import { SEVERITIES as SEVERITIES_CONSTANTS } from '@/lib/constants/severities'
export const SEVERITIES: Record<ISeverity, string> = {
  [SEVERITIES_CONSTANTS.CRITICAL]: 'Critical',
  [SEVERITIES_CONSTANTS.HIGH]: 'High',
  [SEVERITIES_CONSTANTS.MEDIUM]: 'Medium',
  [SEVERITIES_CONSTANTS.LOW]: 'Low',
} as const
